(function ( $ ) {

    $(document).ready(function () {

        $('.expand-btn').click(function () {
            $(this).closest('.image-position').toggleClass('expanded');
            $(this).closest('.custom-block').toggleClass('img-resize-enabled');
        });

        $('.page-header .brand-button').on('click', function (e) {
            if ( $(this).attr('href') === '#' || $(this).attr('href') === '' ) {
                e.preventDefault();
                var $contactForm = $('.page-form');
                if ( $contactForm.length > 0 ) {
                    $('html, body').animate({
                        scrollTop: $contactForm.offset().top - 0.15 * document.documentElement.clientHeight
                    }, 400)
                }
            }
        });

    });
})( jQuery )
